const recommendedHashtags = {
    ko: ["#일상", "#아이돌", "#육아", "#커플", "#교육", "#광고"],
    en: ["#Daily", "#Idol", "#infant_care", "#Couple", "#Education", "#Advertising"],
    jp: ["#日常", "#アイドル", "#育児", "#カップル", "#教育", "#広告"]
}

export const GetRecommendedHashtag = lang => {
    return recommendedHashtags[lang] || recommendedHashtags['en']
}